// third party imports
import React, { useState, useEffect, useContext } from "react";

// internal rebet imports
import "./stylesPrizeRedemptionManualReview.css";
import { SIDER_TABS } from "../../../utils/Constants";
import Layout from "../../CommonComponents/Layout/Layout";

// component imports
import RebetLoader from "../../CommonComponents/RebetLoader/RebetLoader";
import DeleteIcon from "../../../assets/icons/ic_delete_red.png";
import EditIcon from "../../../assets/icons/ic_edit.svg";

import createPrivateAdminPanelInstance from "../../../api/PrivateAdminPanelInstance";
import { API_ROUTES } from "../../../api/ApiRoutes";
import PaymentsInfo from "../PaymentsInfo/PaymentsInfo";
import DeleteRowPopup from "../DeleteRowPopup/DeleteRowPopup";
import { formatNumber } from "chart.js/helpers";
import { Badge, Card, Table, Select, Popover, Modal } from "antd";
import { Option } from "antd/es/mentions";

import AppContext from "../../../context/AppContext";
import CustomAutoComplete from "../../CommonComponents/CustomAutoComplete/CustomAutoComplete";
import ExportToXlsxButton from "../../CommonComponents/ExportToXlsxButton/ExportToXlsxButton";
import UpdateStatusModal from "./UpdateStatusModal/UpdateStatusModal";

// asset imports

const generateFakeData = (count) => {
  return Array.from({ length: count }, (_, i) => ({
    user_id: i + 1,
    transaction_id: i + 1,
    username: `User ${i + 1}`,
    amount: Math.floor(Math.random() * 1000) + 1,
  }));
};

const PrizeRedemptionManualReview = () => {
  // non-state variables
  const token = JSON.parse(localStorage.getItem("token"));
  const PrivateAdminPanelInstance = createPrivateAdminPanelInstance(
    token?.IdToken
  );

  const { setActiveSidebarTab } = useContext(AppContext);

  // state variables
  const [isApiRunning, setIsApiRunning] = useState(false);

  const [paymentsTable, setPaymentsTable] = useState([
    {
      user_id: 1,
      username: "Rebetuser",
      email: "user@rebet.app",
      amount: 100,
      status: "In Review",
      reason: "",
    },
    {
      user_id: 2,
      username: "Rebetuser2",
      email: "user@rebet.app",
      amount: 200,
      status: "In Review",
      reason: "",
    },
    {
      user_id: 3,
      username: "Rebetuser3",
      email: "user@rebet.app",
      amount: 300,
      status: "In Review",
      reason: "",
    },
  ]);

  const [filteredPaymentsTable, setFilteredPaymentsTable] =
    useState(paymentsTable);
  const [pageSize, setPageSize] = useState(10);
  const [selectedOption, setSelectedOption] = useState("username");
  const [allOptions, setAllOptions] = useState([]);
  const [dataToExport, setDataToExport] = useState(filteredPaymentsTable);
  const [isUpdateStatusModalOpen, setIsUpdateStatusModalOpen] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);

  const changeStatus = (record) => {
    console.log(record);
    const updatedPaymentsTable = paymentsTable.map((payment) =>
      payment.user_id === record.user_id ? record : payment
    );
    console.log(updatedPaymentsTable);
    setPaymentsTable(updatedPaymentsTable);
    setFilteredPaymentsTable(updatedPaymentsTable);
  };

  // api functions
  useEffect(() => {}, []);

  useEffect(() => {
    setActiveSidebarTab(SIDER_TABS.PAYMENTS, "Prize Redemption Manual Review");
  }, [setActiveSidebarTab]);

  // table columns
  const columns = [
    {
      title: "ID",
      dataIndex: "user_id",
      key: "user_id",
      render: (user_id, record) => (
        <div style={{ display: "flex", alignItems: "center" }}>
          {record.retry_count > 0 ? (
            <Badge.Ribbon text="Error" color="red">
              <Card
                size="small"
                style={{
                  backgroundColor: "transparent",
                  color: "#FFFFFF",
                  border: "none",
                  padding: "12px 0",
                }}
              >
                <p>{user_id}</p>
              </Card>
            </Badge.Ribbon>
          ) : (
            <p>{user_id}</p>
          )}
        </div>
      ),
    },
    {
      title: "Username",
      dataIndex: "username",
      key: "username",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      render: (email, record) => (
        <div>
          <p>{record?.email || "-"}</p>
        </div>
      ),
    },
    {
      title: "Amount ($)",
      dataIndex: "amount",
      key: "amount",
    },
    {
      title: "Accept/Decline",
      key: "accept-decline",
      render: (_, record) => (
        <img
          className="delete-icon"
          src={EditIcon}
          alt="edit icon"
          onClick={() => {
            setIsUpdateStatusModalOpen(true);
            setSelectedRecord(record);
          }}
        />
      ),
    },
  ];

  useEffect(() => {
    if (selectedOption === "user_id") {
      setAllOptions(
        paymentsTable.map((payment) => ({
          label: payment.user_id,
          value: payment.user_id,
          user_id: payment.user_id,
        }))
      );
    } else if (selectedOption === "username") {
      setAllOptions(
        paymentsTable.map((payment) => ({
          label: payment.username,
          value: payment.username,
          user_id: payment.user_id,
        }))
      );
    } else {
      setAllOptions(
        paymentsTable.map((payment) => ({
          label: payment.email,
          value: payment.email,
          user_id: payment.user_id,
        }))
      );
    }
  }, [selectedOption, paymentsTable]);

  const handleChange = (value) => {
    const selectedPayment = allOptions.find((option) => option.value === value);
    setFilteredPaymentsTable(
      paymentsTable.filter(
        (payment) => payment[selectedOption] === selectedPayment.value
      )
    );
  };

  return (
    <Layout>
      <Modal
        open={isUpdateStatusModalOpen}
        onCancel={() => setIsUpdateStatusModalOpen(false)}
        footer={null}
        closeIcon={false}
        width={450}
      >
        <UpdateStatusModal
          handleCancel={() => setIsUpdateStatusModalOpen(false)}
          handleNotesChange={() => {}}
          selectedRecord={selectedRecord}
          changeStatus={changeStatus}
        />
      </Modal>
      <div className="prize-redemption-manual-review">
        <div className="prize-redemption-manual-review-table">
          <>
            <div className="head-controls">
              <div className="header-text-container">
                <p className="header-text">Prize Redemption Manual Review</p>
              </div>
              <div className="prize-redemption-manual-review-header-actions-container">
                <div className="wallet-transactions-header-select">
                  <span>Search by</span>
                  <Select
                    defaultValue={selectedOption}
                    onChange={(value) => setSelectedOption(value)}
                    options={[
                      { label: "Username", value: "username" },
                      { label: "User ID", value: "user_id" },
                      // { label: "Email", value: "email" },
                    ]}
                  />
                </div>
                <div className="prize-redemption-manual-review-header-actions-container-search-bar">
                  <CustomAutoComplete
                    allOptions={allOptions}
                    handleChange={handleChange}
                    clearOptions={() => {
                      setFilteredPaymentsTable(paymentsTable);
                    }}
                    selector={"value"}
                    bgColor={"#23232B"}
                  />
                </div>
                <div className="export-to-xlsx-button-container">
                  <ExportToXlsxButton
                    data={dataToExport}
                    filename={"prize-redemption-manual-review.xlsx"}
                  />
                </div>
              </div>
            </div>

            <div className="prize-redemption-manual-review-content-container">
              {isApiRunning ? (
                <RebetLoader height={"100px"} width={"100px"} />
              ) : (
                <>
                  <div className="table-container">
                    <Table
                      dataSource={filteredPaymentsTable}
                      columns={columns}
                      pagination={{ pageSize }}
                      scroll={{ x: 1000, y: 400 }}
                      onChange={(pagination) => {
                        setPageSize(pagination.pageSize);
                      }}
                      rowKey={(record) =>
                        `${record.user_id}-${record.amount}-${Math.random(
                          0,
                          150
                        )}`
                      }
                    />
                  </div>
                </>
              )}
            </div>
          </>
        </div>
      </div>
    </Layout>
  );
};

export default PrizeRedemptionManualReview;
